import AccessFooter from "../../../assets/svg/Solutions/AccessFooter.svg";
import clsx from "clsx";

export const Access = ({ customTitle, customParagraph, cover, noText }) => {
  return (
    <section className={clsx("access-background", cover && "cover")}>
      <section className="section-layout">
        <article className="access-text">
          {!noText && (
            <>
              <p className="access-head">{customTitle || "Don't settle for half the story"}</p>
              <p className="access-paragraph">
                {customParagraph ||
                  "Demyst gives you access to all of the data you need. Evaluate thousands of data attributes from hundreds of possible data connectors all pulled into your own custom-built APIs for instant data deployment."}
              </p>
            </>
          )}
          <img src={AccessFooter.src} alt="" loading="lazy" width="1680" height="288" />
        </article>
      </section>
    </section>
  );
};
